import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { LoaderService } from '@app/shared/services/loader.service';
import { tap } from 'rxjs/operators';
import { InfineScrollLoaderService } from '@app/shared/services/infine-scroll-loader.service';

declare var swal: any;

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    private totalRequests = 0;
    constructor(
        private infineScrollLoaderService: InfineScrollLoaderService,
        private loaderService: LoaderService
    ) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.totalRequests++;
        this.loaderService.display(true);
        return next.handle(req).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    this.decreaseRequests();
                }
            }, error => {
                this.decreaseRequests();
            })
        );
    }

    private decreaseRequests() {
        this.totalRequests--;
        if (this.totalRequests === 0) {
            this.loaderService.display(false);
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/http-interceptors/loader-interceptor.ts